import {
	ApiClientFactory
} from '@/ApiClientFactory';
import {
	API_V4_URL
} from '@/Variables';

let client = new ApiClientFactory(API_V4_URL);

export const ChatClient = {


	getPrivateChatByRecipient(recipient_id) {
		return client.post('chat/private', {
			'recipient_id': recipient_id
		})
	},



	/**
	 * Sends a message.
	 *
	 */
	sendMessage(chat_id, message) {
		return client.post(`chat/${chat_id}/messages`, {
			'message': message,
			'type': 'private'
		});
	},
	/**
	 * Returns chat messages.
	 *
	 * {param} chatId
	 */
	getMessages(chatId) {
		return client.get('chat/' + chatId + '/messages');
	},

	/**
	 * Returns s single chat.
	 *
	 * param {chatId}
	 */
	getChat(chatId) {
		return client.get('chat/' + chatId);
	},




};